import loadable from '@loadable/component';

export const OrgDashboardPreviewEventPageLoadable = loadable(
  () => import('./OrgDashboardPreviewEventPage'),
  { resolveComponent: (module) => module.OrgDashboardPreviewEventPage },
);
